import { ArrowRight, CheckCircle2, Star, Phone, Package, Clock, Shield, Home, ChevronDown, Truck, Users, Sparkles, Box } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Contact from '../components/Contact';

export default function Komplettumzug() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const benefits = [
    'Komplettumzug Schweiz Deutschland - Alles aus einer Hand',
    'Fixpreis-Garantie für Umzug Schweiz Deutschland',
    'Professionelle Verpackung für internationalen Umzug',
    'Vollständige Zollabwicklung Schweiz Deutschland inklusive',
    'Versicherung für Umzugsgut Schweiz Deutschland',
    'Erfahrene Umzugsfirma Schweiz Deutschland',
  ];

  const includedServices = [
    {
      icon: Box,
      title: 'Verpackung',
      items: [
        { text: 'Professionelles Verpackungsmaterial', link: '/verpackungsmaterial' },
        { text: 'Sorgfältiges Einpacken aller Gegenstände', link: null },
        { text: 'Spezialverpackung für empfindliche Güter', link: null },
        { text: 'Beschriftung aller Kartons', link: null },
      ],
    },
    {
      icon: Truck,
      title: 'Transport',
      items: [
        { text: 'Moderne, gepflegte LKW-Flotte', link: null },
        { text: 'Erfahrene, geschulte Fahrer', link: null },
        { text: 'Direkttransport ohne Umwege', link: null },
        { text: 'GPS-Tracking während der Fahrt', link: null },
      ],
    },
    {
      icon: Package,
      title: 'Montage',
      items: [
        { text: 'Demontage in der alten Wohnung', link: null },
        { text: 'Fachmännischer Transport', link: null },
        { text: 'Montage in der neuen Wohnung', link: null },
        { text: 'Möbel werden am gewünschten Platz aufgestellt', link: null },
      ],
    },
    {
      icon: Sparkles,
      title: 'Zusatzleistungen',
      items: [
        { text: 'Komplette Zollabwicklung', link: '/zollabwicklung' },
        { text: 'Endreinigung der alten Wohnung', link: '/endreinigung' },
        { text: 'Entsorgung von Alt-Mobiliar', link: null },
        { text: 'Zwischenlagerung möglich', link: '/zwischenlagerung' },
      ],
    },
  ];

  const whyChooseUs = [
    {
      icon: Shield,
      title: 'Rundum sorglos',
      description: 'Von der ersten Besichtigung bis zur finalen Einrichtung kümmern wir uns um alles. Sie können sich entspannt zurücklehnen – wir regeln den gesamten Umzug professionell.',
    },
    {
      icon: Users,
      title: 'Erfahrenes Team',
      description: 'Über 15 Jahre Erfahrung mit internationalen Umzügen. Unser geschultes Personal behandelt Ihre Möbel mit grösster Sorgfalt und Professionalität.',
    },
    {
      icon: Clock,
      title: 'Pünktlich & Zuverlässig',
      description: 'Wir halten vereinbarte Termine ein. Durch sorgfältige Planung und Koordination läuft Ihr Umzug nach Zeitplan – ohne böse Überraschungen.',
    },
    {
      icon: Home,
      title: 'Fixpreis-Garantie',
      description: 'Nach der Besichtigung erhalten Sie einen transparenten Fixpreis. Keine versteckten Kosten, keine Nachforderungen – Sie wissen genau, was Sie bezahlen.',
    },
  ];

  const householdSizes = [
    {
      size: '1-2 Zimmer Wohnung',
      volume: '15-25m³',
      duration: '1 Tag',
      price: 'ab CHF 2\'400.–',
      ideal: 'Singles, Studenten, kleine Wohnungen',
    },
    {
      size: '3-4 Zimmer Wohnung',
      volume: '30-45m³',
      duration: '1-2 Tage',
      price: 'ab CHF 3\'800.–',
      ideal: 'Paare, kleine Familien, Standard-Haushalte',
    },
    {
      size: '5-6 Zimmer Haus',
      volume: '50-70m³',
      duration: '2-3 Tage',
      price: 'ab CHF 6\'500.–',
      ideal: 'Familien, grosse Haushalte, Einfamilienhäuser',
    },
  ];

  const testimonials = [
    {
      name: 'Familie Müller',
      location: 'Zürich → München',
      text: 'Unser kompletter Hausrat wurde professionell verpackt und transportiert. Das Team war super freundlich und alles lief perfekt. Absolut empfehlenswert!',
      rating: 5,
    },
    {
      name: 'Peter S.',
      location: 'Basel → Stuttgart',
      text: 'Ich war anfangs skeptisch, aber der Umzug war stressfrei von A bis Z. Fixpreis wurde eingehalten, nichts ging kaputt. Top Service!',
      rating: 5,
    },
    {
      name: 'Familie Weber',
      location: 'Bern → Frankfurt',
      text: 'Mit zwei Kindern war ich sehr nervös wegen dem Umzug. Das Team hat alles perfekt organisiert – sogar die Endreinigung. Danke für die tolle Arbeit!',
      rating: 5,
    },
  ];

  const processSteps = [
    {
      step: '1',
      title: 'Unverbindliche Anfrage',
      description: 'Kontaktieren Sie uns per Telefon, E-Mail oder Formular. Wir besprechen Ihre Wünsche und vereinbaren einen Termin zur kostenlosen Besichtigung.',
    },
    {
      step: '2',
      title: 'Kostenlose Besichtigung',
      description: 'Unser Experte begutachtet vor Ort (oder per Video) Ihren Hausrat, berechnet das Volumen und bespricht alle Details mit Ihnen.',
    },
    {
      step: '3',
      title: 'Fixpreis-Offerte',
      description: 'Sie erhalten eine transparente, schriftliche Offerte mit Fixpreis. Keine versteckten Kosten, keine Überraschungen.',
    },
    {
      step: '4',
      title: 'Terminvereinbarung',
      description: 'Nach Ihrer Zusage legen wir gemeinsam den Umzugstermin fest und koordinieren alle Details (Zollpapiere, Parkbewilligung etc.).',
    },
    {
      step: '5',
      title: 'Verpackung & Demontage',
      description: 'Unser Team verpackt Ihren gesamten Hausrat professionell, demontiert Möbel und bereitet alles für den Transport vor.',
    },
    {
      step: '6',
      title: 'Transport & Zoll',
      description: 'Wir transportieren Ihr Umzugsgut sicher nach Deutschland und übernehmen die komplette Zollabwicklung am Grenzübergang.',
    },
    {
      step: '7',
      title: 'Lieferung & Montage',
      description: 'Ihre Möbel werden an die neue Adresse geliefert, aufgebaut und am gewünschten Platz positioniert.',
    },
    {
      step: '8',
      title: 'Endreinigung (optional)',
      description: 'Auf Wunsch übernehmen wir die professionelle Endreinigung Ihrer alten Wohnung – abzugsbereit.',
    },
  ];

  const faqs = [
    {
      question: 'Was kostet ein Komplettumzug von der Schweiz nach Deutschland?',
      answer: 'Die Kosten für einen Komplettumzug hängen von mehreren Faktoren ab:<br><br>• <strong>Haushaltsgrösse</strong> (Anzahl Zimmer / Volumen in m³)<br>• <strong>Distanz</strong> (z.B. Zürich-München oder Basel-Hamburg)<br>• <strong>Etage</strong> (mit oder ohne Lift)<br>• <strong>Zusatzleistungen</strong> (Endreinigung, Entsorgung, Lagerung)<br><br>Als Richtwerte: 2-Zimmer-Wohnung ab CHF 2\'400.–, 4-Zimmer-Wohnung ab CHF 3\'800.–, 6-Zimmer-Haus ab CHF 6\'500.–. Nach der kostenlosen Besichtigung erhalten Sie einen verbindlichen Fixpreis.'
    },
    {
      question: 'Was ist alles im Komplettumzug enthalten?',
      answer: 'Unser Komplettumzug-Service umfasst:<br><br><strong>✓ Professionelle Verpackung</strong> – Verpackungsmaterial, Einpacken aller Gegenstände<br><strong>✓ Demontage & Montage</strong> – Möbel werden ab- und wieder aufgebaut<br><strong>✓ Transport</strong> – Mit modernen LKWs direkt zu Ihrer neuen Adresse<br><strong>✓ Zollabwicklung</strong> – Alle Zollformalitäten inklusive<br><strong>✓ Transportversicherung</strong> – Ihr gesamter Hausrat ist versichert<br><strong>✓ Trägerarbeiten</strong> – Hoch- und Runtertragen aller Gegenstände<br><br>Optional: Endreinigung, Entsorgung, Zwischenlagerung'
    },
    {
      question: 'Wie lange dauert ein Komplettumzug von der Schweiz nach Deutschland?',
      answer: 'Die Dauer eines Komplettumzugs hängt von der Haushaltsgrösse ab:<br><br>• <strong>1-2 Zimmer:</strong> 1 Tag (Verpackung + Transport + Lieferung)<br>• <strong>3-4 Zimmer:</strong> 1-2 Tage<br>• <strong>5-6 Zimmer:</strong> 2-3 Tage<br>• <strong>Grosses Haus:</strong> 3-4 Tage<br><br>Der Transport selbst dauert je nach Distanz 4-8 Stunden. In den meisten Fällen erfolgt die Lieferung am gleichen oder nächsten Tag.'
    },
    {
      question: 'Muss ich selbst etwas verpacken oder übernehmen Sie das?',
      answer: 'Sie müssen <strong>nichts selbst verpacken</strong> – wir übernehmen das komplett! Unser Team bringt professionelles Verpackungsmaterial mit und verpackt Ihren gesamten Hausrat fachgerecht:<br><br>• Möbel werden mit Decken und Folie geschützt<br>• Geschirr und Gläser mit speziellem Packpapier<br>• Elektronikgeräte mit Luftpolsterfolie<br>• Alle Kartons werden beschriftet<br><br>Wenn Sie möchten, können Sie natürlich persönliche Gegenstände selbst verpacken. Wir stellen Ihnen dafür kostenlos Umzugskartons zur Verfügung.'
    },
    {
      question: 'Ist mein Umzugsgut während des Transports versichert?',
      answer: 'Ja, Ihr gesamter Hausrat ist während des kompletten Umzugs <strong>vollumfänglich versichert</strong>. Die Transportversicherung ist im Preis inbegriffen und deckt Schäden durch:<br><br>• Transport (Beschädigung im LKW)<br>• Be- und Entladen<br>• Unfälle während der Fahrt<br><br>Standardversicherung bis CHF 100\'000 inklusive. Bei besonders wertvollen Haushalten (über CHF 100\'000) können Sie eine höhere Versicherungssumme abschliessen.'
    },
    {
      question: 'Was passiert mit der Zollabwicklung?',
      answer: 'Die <strong>komplette Zollabwicklung ist im Komplettumzug enthalten</strong> – ohne Aufpreis! Wir kümmern uns um:<br><br>• Erstellung aller Zolldokumente (Übersiedlungsgutliste, Zollanmeldung)<br>• Voranmeldung beim deutschen Zoll<br>• Verzollung am Grenzübergang<br>• Zollfreigabe<br><br>Sie müssen nur die Abmeldebescheinigung aus der Schweiz vorlegen. Dann ist die Einfuhr Ihres Umzugsguts nach Deutschland zoll- und steuerfrei. Wir informieren Sie rechtzeitig über alle benötigten Dokumente.'
    },
    {
      question: 'Bieten Sie auch Endreinigung der alten Wohnung an?',
      answer: 'Ja, wir bieten eine <strong>professionelle Endreinigung</strong> als Zusatzleistung an. Unsere Reinigungsprofis sorgen dafür, dass Ihre alte Wohnung <strong>abzugsbereit</strong> ist:<br><br>• Reinigung aller Räume (Böden, Fenster, Sanitär)<br>• Küche (inkl. Backofen, Kühlschrank)<br>• Badezimmer (inkl. Armaturen, Fugen)<br>• Entfernung von Kleberesten, Bohrlöchern<br><br>So sparen Sie sich den Stress und stellen sicher, dass Sie die Kaution zurückerhalten. Die Kosten für die Endreinigung werden in der Offerte separat ausgewiesen.'
    },
    {
      question: 'Können Sie auch kurzfristig einen Komplettumzug durchführen?',
      answer: 'Ja, kurzfristige Umzüge sind möglich – je nach Verfügbarkeit. Bei einem <Link to="/express-umzuege" className="text-slate-900 font-semibold hover:underline">Express-Umzug</Link> können wir oft innerhalb von <strong>5-7 Tagen</strong> starten. Für optimale Planung und beste Preise empfehlen wir jedoch eine Vorlaufzeit von <strong>3-4 Wochen</strong>.<br><br>Kontaktieren Sie uns am besten sofort für eine Verfügbarkeitsanfrage. Wir versuchen immer, eine Lösung zu finden!'
    },
    {
      question: 'Was passiert, wenn meine neue Wohnung in Deutschland noch nicht bezugsbereit ist?',
      answer: 'Kein Problem! Wir bieten <Link to="/zwischenlagerung" className="text-slate-900 font-semibold hover:underline">Zwischenlagerung</Link> für Ihren gesamten Hausrat an:<br><br>• Sichere, überwachte Lagerhallen<br>• Klimatisiert und trocken<br>• Versichert während der gesamten Lagerzeit<br>• Flexible Lagerdauer (Tage, Wochen, Monate)<br>• Zugang auf Anfrage möglich<br><br>Die Kosten für die Zwischenlagerung berechnen sich nach Volumen und Lagerdauer. Wir erstellen Ihnen gerne eine individuelle Offerte.'
    },
    {
      question: 'Wie wird der Fixpreis garantiert? Können nachträglich Kosten entstehen?',
      answer: 'Nach der Besichtigung erhalten Sie einen <strong>verbindlichen Fixpreis</strong> – das ist unser Versprechen. Nachträgliche Kosten entstehen nur, wenn:<br><br>• Sie zusätzliche Leistungen wünschen (die nicht in der Offerte waren)<br>• Das Umzugsvolumen deutlich grösser ist als bei der Besichtigung<br>• Zufahrtsbedingungen stark von den angegebenen abweichen<br><br>In 99% aller Fälle bleibt es beim vereinbarten Fixpreis. Transparenz und Ehrlichkeit sind uns sehr wichtig!'
    }
  ];

  const features = [
    'Kostenlose Besichtigung vor Ort oder per Video',
    'Fixpreis-Garantie ohne versteckte Kosten',
    'Professionelle Verpackung mit hochwertigem Material',
    'Erfahrenes, geschultes Umzugsteam',
    'Moderne LKW-Flotte in Top-Zustand',
    'Komplette Zollabwicklung inklusive',
    'Vollständige Transportversicherung',
    'Montage und Demontage aller Möbel',
    'Optionale Endreinigung abzugsbereit',
    'Entsorgung von Alt-Mobiliar möglich',
    'Zwischenlagerung bei Bedarf',
    'Flexible Terminplanung nach Ihren Wünschen',
  ];

  return (
    <div className="min-h-screen bg-white">
      <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-20 min-h-[700px] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} />
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold mb-6 border border-white/20">
              Komplettumzug Schweiz → Deutschland
            </div>

            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Komplettumzug von der Schweiz nach Deutschland
            </h1>

            <p className="text-xl md:text-2xl text-slate-200 mb-8 leading-relaxed">
              Alles aus einer Hand – Von der Verpackung bis zur Montage. Stressfrei und zum Fixpreis.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button
                onClick={scrollToContact}
                className="bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold hover:bg-slate-100 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 flex items-center justify-center space-x-2"
              >
                <span>Gratis Offerte erhalten</span>
                <ArrowRight className="w-5 h-5" />
              </button>
              <a
                href="tel:0800700100"
                className="bg-slate-700/50 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold hover:bg-slate-700 transition-all duration-300 border border-white/20 flex items-center justify-center space-x-2"
              >
                <Phone className="w-5 h-5" />
                <span>0800 700 100</span>
              </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              {benefits.slice(0, 3).map((benefit, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <CheckCircle2 className="w-6 h-6 text-green-400 mb-2 mx-auto" />
                  <p className="text-sm font-medium">{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Was ist ein Komplettumzug?
              </h2>
              <p className="text-xl text-slate-600 leading-relaxed">
                Ein Komplettumzug bedeutet, dass wir uns um <strong>alles kümmern</strong> – von der ersten Kiste bis zum letzten Möbelstück. Sie müssen nichts tun ausser zusehen, wie Ihr gesamter Hausrat professionell von der Schweiz nach Deutschland transportiert wird. Das ist der <strong>stressfreie Rundum-Service</strong> für Ihren internationalen Umzug.
              </p>
              <p className="text-lg text-slate-600 leading-relaxed mt-4">
                Wir bieten <strong>Komplettumzug Schweiz Deutschland</strong> aus allen Regionen: <Link to="/umzug-zuerich-deutschland" className="text-slate-900 font-semibold hover:underline">Umzug Zürich Deutschland</Link>, <Link to="/umzug-basel-deutschland" className="text-slate-900 font-semibold hover:underline">Umzug Basel Deutschland</Link>, <Link to="/umzug-bern-deutschland" className="text-slate-900 font-semibold hover:underline">Umzug Bern Deutschland</Link> und <Link to="/umzug-luzern-deutschland" className="text-slate-900 font-semibold hover:underline">Umzug Luzern Deutschland</Link>. Für Unternehmen bieten wir auch <Link to="/firmenumzuege" className="text-slate-900 font-semibold hover:underline">Firmenumzug Schweiz Deutschland</Link>. Mehr Infos zu <Link to="/preise" className="text-slate-900 font-semibold hover:underline">Umzug Schweiz Deutschland Kosten</Link>.
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 border-2 border-green-200">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center">
                Im Komplettumzug enthalten:
              </h3>
              <div className="grid md:grid-cols-2 gap-3">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0" />
                    <span className="text-slate-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Unsere Leistungen im Detail
              </h2>
              <p className="text-xl text-slate-600">
                Alles was Sie für einen erfolgreichen Umzug brauchen
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {includedServices.map((service, index) => {
                const Icon = service.icon;
                return (
                  <div key={index} className="bg-white rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-300 transition-all duration-300">
                    <div className="bg-slate-100 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                      <Icon className="w-7 h-7 text-slate-800" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-4">{service.title}</h3>
                    <ul className="space-y-3">
                      {service.items.map((item, idx) => (
                        <li key={idx} className="flex items-start space-x-2">
                          <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                          {item.link ? (
                            <Link to={item.link} className="text-slate-600 hover:text-slate-900 hover:underline">
                              {item.text}
                            </Link>
                          ) : (
                            <span className="text-slate-600">{item.text}</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Preisbeispiele Komplettumzug
              </h2>
              <p className="text-xl text-slate-600">
                Richtwerte für verschiedene Haushaltsgrössen
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {householdSizes.map((household, index) => (
                <div key={index} className="bg-slate-50 rounded-2xl p-8 border-2 border-slate-200 hover:border-slate-800 transition-all duration-300">
                  <h3 className="text-2xl font-bold text-slate-900 mb-4">{household.size}</h3>
                  <div className="space-y-3 mb-6">
                    <div className="flex justify-between text-sm">
                      <span className="text-slate-600">Volumen:</span>
                      <span className="font-semibold text-slate-900">{household.volume}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-slate-600">Dauer:</span>
                      <span className="font-semibold text-slate-900">{household.duration}</span>
                    </div>
                  </div>
                  <div className="text-3xl font-bold text-slate-900 mb-4">{household.price}</div>
                  <div className="text-sm text-slate-600 italic mb-6">{household.ideal}</div>
                  <div className="pt-6 border-t border-slate-300">
                    <ul className="space-y-2 text-sm text-slate-600">
                      <li className="flex items-center space-x-2">
                        <CheckCircle2 className="w-4 h-4 text-green-600 flex-shrink-0" />
                        <span>Komplettservice inklusive</span>
                      </li>
                      <li className="flex items-center space-x-2">
                        <CheckCircle2 className="w-4 h-4 text-green-600 flex-shrink-0" />
                        <span>Verpackung & Montage</span>
                      </li>
                      <li className="flex items-center space-x-2">
                        <CheckCircle2 className="w-4 h-4 text-green-600 flex-shrink-0" />
                        <span>Zoll & Versicherung</span>
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 text-center">
              <p className="text-slate-600 mb-4">
                * Preise sind Richtwerte und können je nach Distanz, Etage und Zusatzleistungen variieren.
              </p>
              <button
                onClick={scrollToContact}
                className="bg-slate-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-slate-800 transition-all duration-300 inline-flex items-center space-x-2"
              >
                <span>Jetzt individuelle Offerte einholen</span>
                <ArrowRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Warum Komplettumzug mit uns?
              </h2>
              <p className="text-xl text-slate-600">
                Ihre Vorteile auf einen Blick
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {whyChooseUs.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="bg-white rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-300 transition-all duration-300 hover:shadow-lg">
                    <div className="bg-slate-800 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">{item.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{item.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                So läuft Ihr Komplettumzug ab
              </h2>
              <p className="text-xl text-slate-600">
                8 Schritte zum stressfreien Umzug
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {processSteps.map((step, index) => (
                <div key={index} className="bg-slate-50 rounded-2xl p-6 border-2 border-slate-100">
                  <div className="bg-slate-900 text-white w-12 h-12 rounded-xl flex items-center justify-center font-bold text-xl mb-4">
                    {step.step}
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-3">{step.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Das sagen unsere Kunden
              </h2>
              <p className="text-xl text-slate-600">
                Über 500 erfolgreiche Komplettumzüge pro Jahr
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-white rounded-2xl p-6 border-2 border-slate-100">
                  <div className="flex items-center mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-slate-700 mb-4 leading-relaxed">"{testimonial.text}"</p>
                  <div className="border-t border-slate-200 pt-4">
                    <div className="font-semibold text-slate-900">{testimonial.name}</div>
                    <div className="text-sm text-slate-500">{testimonial.location}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Häufig gestellte Fragen
              </h2>
              <p className="text-xl text-slate-600">
                Alles was Sie über Komplettumzüge wissen müssen
              </p>
            </div>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-slate-50 rounded-xl border-2 border-slate-100 overflow-hidden transition-all duration-300 hover:border-slate-300"
                >
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left"
                  >
                    <span className="font-semibold text-slate-900 pr-4">{faq.question}</span>
                    <ChevronDown
                      className={`w-5 h-5 text-slate-600 transition-transform duration-300 flex-shrink-0 ${
                        openFaq === index ? 'transform rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openFaq === index && (
                    <div className="px-6 pb-5">
                      <p className="text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Contact />
    </div>
  );
}
